import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminKycBack = _resolveComponent("AdminKycBack")!
  const _component_SharedUpload = _resolveComponent("SharedUpload")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_component_AdminKycBack, {
      title: "Документы",
      onBack: _ctx.handleBack
    }, null, 8, ["onBack"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('form'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('form-group'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form-block'))
        }, [
          _createElementVNode("h4", {
            class: _normalizeClass(_ctx.b('form-title'))
          }, _toDisplayString(_ctx.$t("Паспорт или ВУ")), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('form-fields', { passport: true }))
          }, [
            _createVNode(_component_SharedUpload, {
              document: _ctx.documents['kyc-personal-documents-passport-selfie'],
              "is-readonly": true,
              "is-download": true
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                _hoisted_1,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("с фото")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedUpload, {
              document: 
                _ctx.documents['kyc-personal-documents-passport-organization']
              ,
              "is-readonly": true,
              "is-download": true
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("кем выдан")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedUpload, {
              document: _ctx.documents['kyc-personal-documents-passport-address'],
              "is-readonly": true,
              "is-download": true
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("с пропиской")), 1)
              ]),
              _: 1
            }, 8, ["document"])
          ], 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form-block'))
        }, [
          _createElementVNode("h4", {
            class: _normalizeClass(_ctx.b('form-title'))
          }, _toDisplayString(_ctx.$t("Селфи")), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('form-fields', { selfie: true }))
          }, [
            _createVNode(_component_SharedUpload, {
              document: _ctx.documents['kyc-personal-documents-selfie'],
              "is-readonly": true,
              isCenter: true,
              "is-label": false,
              "is-download": true
            }, null, 8, ["document"])
          ], 2)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('form-block'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('form-title'))
        }, _toDisplayString(_ctx.$t("Соглашения")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form-fields', { default: true }))
        }, [
          _createVNode(_component_SharedUpload, {
            document: _ctx.documents['kyc-personal-documents-questionnaire'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("физического лица")), 1)
            ]),
            _: 1
          }, 8, ["document"]),
          _createVNode(_component_SharedUpload, {
            document: _ctx.documents['kyc-personal-documents-personal-data'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Согласие на обработку")) + " ", 1),
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("персональных данных")), 1)
            ]),
            _: 1
          }, 8, ["document"]),
          _createVNode(_component_SharedUpload, {
            document: _ctx.documents['kyc-personal-documents-declaration'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Декларация")) + " ", 1),
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("о рисках")), 1)
            ]),
            _: 1
          }, 8, ["document"]),
          _createVNode(_component_SharedUpload, {
            document: _ctx.documents['kyc-personal-documents-broker'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Брокерский")) + " ", 1),
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("договор")), 1)
            ]),
            _: 1
          }, 8, ["document"])
        ], 2)
      ], 2),
      (_ctx.files.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('form-block'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('form-title'))
            }, _toDisplayString(_ctx.$t("Документы для подтверждения верификации")), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-fields', { verification: true }))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createBlock(_component_SharedUpload, {
                  key: file.uuid,
                  class: _normalizeClass(_ctx.b('form-upload')),
                  document: file,
                  "is-readonly": true,
                  "is-download": true
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(file.name), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "document"]))
              }), 128))
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}